var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6924 0C84.1106 3.82404e-05 87.6924 3.58175 87.6924 8V79.6924C87.6923 84.1106 84.1106 87.6923 79.6924 87.6924H8C3.58175 87.6924 4.14195e-05 84.1106 0 79.6924V8C0 3.58172 3.58172 1.86204e-07 8 0H79.6924ZM46.4453 38.6992L35.4092 23.8906L22.3115 23.8252L39.2129 46.5137L21.959 64.9521L24.8721 65.9814L40.9561 48.8535L52.6045 64.4902H65.666L48.1631 41.0049L64.1377 24.0049L61.2695 22.8613L46.4453 38.6992ZM34.6699 25.3506L45.4277 39.7852L44.9512 40.2959L46.1523 40.7578L62.749 63.0254H53.3398L41.9746 47.7686L42.5186 47.1904L41.1758 46.6963L25.2402 25.3037L34.6699 25.3506Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c87eed5f520e311bc245d01c1100629d.svg";
export { ForwardRef as ReactComponent };